document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    customProduct()
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    customProduct();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    customProduct();
});
$(document).ready(function(){
    customProduct();
})

function customProduct() {

    $('.product').each(function() {     
        if($(this).find('.stars-wrapper').length){
            $(this).find('.p-in-in').prepend($(this).find('.stars-wrapper'));
        }
        else{
            $(this).find('.p-in-in').prepend('<div class="stars-wrapper"><span class="stars star-list"><span class="star star-off"></span><span class="star star-off"></span><span class="star star-off"></span><span class="star star-off"></span><span class="star star-off"></span></span></div>')
        }
        
        if ($(this).find('.price-standard').length) {
            $(this).find('.prices').prepend($(this).find('.price-standard'));
        }
        const quantityHtml = `
           <span class="quantity">
    <span class="increase-tooltip js-increase-tooltip" data-trigger="manual" data-container="body" data-original-title="Nie je možné zakúpiť viac ako 9999 ks." aria-hidden="true" role="tooltip" data-testid="tooltip"></span>
    <span class="decrease-tooltip js-decrease-tooltip" data-trigger="manual" data-container="body" data-original-title="Minimálne množstvo, ktoré je možné zakúpiť, je 1 ks." aria-hidden="true" role="tooltip" data-testid="tooltip"></span>
    <label>
        <input type="number" name="amount" value="1" class="amount" autocomplete="off" data-decimals="0" step="1" min="1" max="9999" aria-label="Množstvo" data-testid="cartAmount">
    </label>
    <button class="increase" type="button" aria-label="Zvýšiť množstvo o 1" data-testid="increase">
        <span class="increase__sign">+</span>
    </button>
    <button class="decrease" type="button" aria-label="Znížiť množstvo o 1" data-testid="decrease">
        <span class="decrease__sign">−</span>
    </button>
</span>
            `;
        if($(this).find('.p-tools form').length){
            if(!$(this).find('.p-tools .quantity').length){
                $(this).find('.p-tools form button').before(quantityHtml);
            }   
        }

    });
}